<template>
  <div>
    <el-dialog
      title="编辑重提国际退款"
      custom-class="overseas-refund-edit-dialog"
      :visible.sync="visible"
      width="800px"
      append-to-body
      destroy-on-close
      @closed="onClosed"
    >
      <div class="edit-dialog-body">
        <el-form ref="form" v-loading="loading" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="退款申请单号">
            <span>{{ form.refundNum || '-' }}</span>
          </el-form-item>
          <el-form-item label="收款编号">
            <span>{{ form.telegraphicTransferNum }}</span>
          </el-form-item>
          <el-form-item label="可用余额">
            <span>{{ form.unusedAmount }}</span>
          </el-form-item>
          <el-form-item label="退款金额" prop="returnAmount">
            <el-input-number v-model="form.returnAmount" :precision="2" :min="0" />
          </el-form-item>
          <el-form-item label="收款单位" prop="payee">
            <el-input v-model="form.payee" />
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="form.bankAccount" />
          </el-form-item>
          <el-form-item label="开户行" prop="openBank">
            <el-input v-model="form.openBank" />
          </el-form-item>
          <el-form-item label="客户联行号" prop="customerBankNo">
            <el-input v-model="form.customerBankNo" placeholder="请输入客户联行号" />
          </el-form-item>
          <el-form-item label="SWIFT CODE" prop="swiftCode">
            <el-input v-model="form.swiftCode" placeholder="请输入SWIFT CODE" />
          </el-form-item>
          <el-form-item label="退款理由" prop="reason">
            <el-input v-model="form.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 8 }" maxlength="3000" show-word-limit />
          </el-form-item>
        </el-form>

        <div v-if="historySnapshots.length" class="history-snapshots">
          <div class="history-title">历史提交镜像（点击回填到上方表单）</div>
          <el-table
            :data="historySnapshots"
            border
            size="mini"
            max-height="180"
            highlight-current-row
            :row-class-name="snapshotRowClass"
            @row-click="applySnapshot"
          >
            <el-table-column prop="version" label="轮次" width="70" align="center" />
            <el-table-column prop="roundStatusLabel" label="结果" width="90" align="center" />
            <el-table-column prop="returnAmount" label="退款金额" width="120" align="right" />
            <el-table-column prop="payee" label="收款单位" min-width="160" show-overflow-tooltip />
            <el-table-column prop="reason" label="退款理由" min-width="140" show-overflow-tooltip />
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click.stop="viewSnapshot(scope.row)">查看</el-button>
                <el-button type="text" @click.stop="applySnapshot(scope.row)">回填</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <span slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">提 交</el-button>
      </span>
    </el-dialog>
    <overseas-refund-detail-dialog ref="snapshotDetailDialog" />
  </div>
</template>

<script>
import { overseasRefundDetail, overseasRefundEdit } from '@/API';
import OverseasRefundDetailDialog from './DetailDialog.vue';

export default {
  name: 'OverseasRefundEditDialog',
  components: {
    OverseasRefundDetailDialog
  },
  data () {
    var checkBankInfo = (rule, value, callback) => {
      if (!this.form.customerBankNo && !this.form.swiftCode) {
        callback(new Error('客户联行号和SWIFT CODE不能同时为空'));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      loading: false,
      submitting: false,
      historySnapshots: [],
      selectedSnapshotId: null,
      form: {
        overseasRefundId: null,
        refundNum: '',
        telegraphicTransferNum: '',
        unusedAmount: null,
        returnAmount: null,
        payee: '',
        bankAccount: '',
        openBank: '',
        customerBankNo: '',
        swiftCode: '',
        reason: ''
      },
      rules: {
        returnAmount: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        payee: [{ required: true, message: '请输入收款单位', trigger: 'blur' }],
        bankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
        openBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        customerBankNo: [{ validator: checkBankInfo, trigger: 'blur' }],
        swiftCode: [{ validator: checkBankInfo, trigger: 'blur' }],
        reason: [{ required: true, message: '请输入退款理由', trigger: 'blur' }]
      }
    };
  },
  methods: {
    open (overseasRefundId) {
      this.visible = true;
      this.loading = true;
      this.historySnapshots = [];
      this.selectedSnapshotId = null;
      overseasRefundDetail({ overseasRefundId })
        .then(res => {
          const data = (res && res.data && res.data.data) || {};
          const apply = data.apply || {};
          this.form.overseasRefundId = overseasRefundId;
          this.form.refundNum = apply.refundNum;
          this.form.telegraphicTransferNum = apply.telegraphicTransferNum;
          this.form.returnAmount = apply.returnAmount;
          this.form.payee = apply.payee;
          this.form.bankAccount = apply.bankAccount;
          this.form.openBank = apply.openBank;
          this.form.customerBankNo = apply.customerBankNo;
          this.form.swiftCode = apply.swiftCode;
          this.form.reason = apply.reason;
          // 驳回待提交仍算互斥，不能再调 getRefundApplyInfoByTTNum；用详情带回的实时余额
          this.form.unusedAmount = data.currentUnusedAmount;
          this.historySnapshots = data.historySnapshots || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    applySnapshot (row) {
      if (!row) return;
      this.selectedSnapshotId = row.snapshotId;
      this.form.returnAmount = row.returnAmount;
      this.form.payee = row.payee || '';
      this.form.bankAccount = row.bankAccount || '';
      this.form.openBank = row.openBank || '';
      this.form.customerBankNo = row.customerBankNo || '';
      this.form.swiftCode = row.swiftCode || '';
      this.form.reason = row.reason || '';
      this.$message.success('已回填第' + (row.version || '') + '轮镜像');
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    snapshotRowClass ({ row }) {
      if (row && row.snapshotId === this.selectedSnapshotId) {
        return 'snapshot-selected-row';
      }
      return '';
    },
    viewSnapshot (row) {
      if (!row || !row.snapshotId) return;
      this.$refs.snapshotDetailDialog && this.$refs.snapshotDetailDialog.openSnapshot(row.snapshotId);
    },
    onClosed () {
      this.historySnapshots = [];
      this.selectedSnapshotId = null;
      this.$refs.form && this.$refs.form.resetFields();
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const {
          overseasRefundId,
          telegraphicTransferNum,
          unusedAmount,
          returnAmount,
          payee,
          bankAccount,
          openBank,
          customerBankNo,
          swiftCode,
          reason
        } = this.form;
        overseasRefundEdit({
          overseasRefundId,
          telegraphicTransferNum,
          unusedAmount,
          returnAmount,
          payee,
          bankAccount,
          openBank,
          customerBankNo,
          swiftCode,
          reason
        })
          .then(res => {
            const data = res && res.data;
            // R-021：ERP 可退不足等由拦截器提示；失败不关弹窗
            if (data && data.status !== '200') {
              return;
            }
            this.visible = false;
            this.$emit('on-ok');
            this.$message.success('重提成功');
          })
          .catch(() => {})
          .finally(() => {
            this.submitting = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.edit-dialog-body {
  max-height: calc(100vh - 200px);
  overflow: hidden;
}
.history-snapshots {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}
.history-title {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
  font-weight: 600;
}
.history-snapshots >>> .snapshot-selected-row {
  background: #ecf5ff;
}
.history-snapshots >>> .el-table__row {
  cursor: pointer;
}
</style>

<style>
/* append-to-body 弹窗，需非 scoped */
.overseas-refund-edit-dialog .el-dialog__body {
  padding-top: 12px;
  padding-bottom: 8px;
  overflow: hidden;
}
</style>
